module.exports = __webpack_public_path__ + "img/248.708e7cb8.png";